
// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import AppFooter from "../AppFooter";
// import { FaTimes, FaShare, FaHome, FaPlus } from "react-icons/fa";

// // make relative paths absolute using your API base
// const toAbs = (baseUrl, p) =>
//   !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith("/") ? "" : "/"}${p}`;

// const isImage = (f) =>
//   f?.mimetype?.startsWith("image/") ||
//   /\.(png|jpe?g|gif|webp|svg)$/i.test(f?.path || f?.url || f || "");

// const isVideo = (f) =>
//   f?.mimetype?.startsWith("video/") ||
//   /\.(mp4|mov|webm|ogg)$/i.test(f?.path || f?.url || f || "");

// const pickMediaFromEvent = (evt) => {
//   // try common server shapes you use in other places
//   const arr = evt?.media || evt?.files || evt?.fileList || [];
//   const primary = Array.isArray(arr) ? arr[0] : arr;
//   if (primary) return primary;

//   return (
//     evt?.cover ||
//     evt?.image ||
//     evt?.image_url ||
//     evt?.thumbnail ||
//     evt?.banner ||
//     null
//   );
// };

// /**
//  * Safely parse dates coming from MySQL/Node.
//  * - Handles ISO strings
//  * - Handles common "YYYY-MM-DD HH:mm:ss" by normalizing to "YYYY-MM-DDTHH:mm:ss"
//  * Returns: Date | null
//  */
// const safeParseDate = (value) => {
//   if (!value) return null;

//   // Already a Date?
//   if (value instanceof Date && !Number.isNaN(value.getTime())) return value;

//   // Try native parse first
//   const d1 = new Date(value);
//   if (!Number.isNaN(d1.getTime())) return d1;

//   // Normalize "YYYY-MM-DD HH:mm:ss" -> "YYYY-MM-DDTHH:mm:ss"
//   if (typeof value === "string" && value.includes(" ")) {
//     const normalized = value.replace(" ", "T");
//     const d2 = new Date(normalized);
//     if (!Number.isNaN(d2.getTime())) return d2;
//   }

//   return null;
// };

// // Hide the tenant default "Timeline" event from list UIs
// const isTimelineEvent = (evt) => {
//   const name = String(evt?.name ?? evt?.title ?? "").trim().toLowerCase();
//   const type = String(evt?.type ?? evt?.eventtype ?? "").trim().toLowerCase();
//   return name === "timeline" || type === "timeline";
// };

// /**
//  * Business rule:
//  * 1) If an event's end date is <= (current date + 1 day), DO NOT display it
//  * 2) If an event's end date is >  (current date + 1 day), DO display it
//  *
//  * Also uses "status" via event.active (schema: t_event.active).
//  * - If event.active is missing (older backend payload), we assume active to avoid breaking existing behavior.
//  */
// // const shouldDisplayEventInList = (evt, cutoffDate) => {
// //   // "status" / active flag handling (supports 1/0, true/false, "1"/"0")
// //   const hasActiveField = evt?.active !== undefined && evt?.active !== null;
// //   const isActive =
// //     !hasActiveField ||
// //     evt.active === true ||
// //     evt.active === 1 ||
// //     evt.active === "1";

// //   if (!isActive) return false;

// //   const end = safeParseDate(evt?.enddate);

// //   // If enddate is missing/invalid, keep it visible (safer fallback; avoids hiding everything)
// //   if (!end) return true;

// //   // Rule 1: enddate <= now+1 day => hide
// //   return end > cutoffDate;
// // };

// const shouldDisplayEventInList = (evt, cutoffDate) => {
//   // ✅ Always hide Timeline
//   if (isTimelineEvent(evt)) return false;

//   // "status" / active flag handling (supports 1/0, true/false, "1"/"0")
//   const hasActiveField = evt?.active !== undefined && evt?.active !== null;
//   const isActive =
//     !hasActiveField ||
//     evt.active === true ||
//     evt.active === 1 ||
//     evt.active === "1";

//   if (!isActive) return false;

//   const end = safeParseDate(evt?.enddate);

//   // If enddate is missing/invalid, keep it visible (safer fallback; avoids hiding everything)
//   if (!end) return true;

//   // Rule 1: enddate <= now+1 day => hide
//   return end > cutoffDate;
// };

// export default function EventList() {
//   const { tenant } = useParams();
//   const navigate = useNavigate();

//   const [events, setEvents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

//   useEffect(() => {
//     document.body.classList.add("eventlist-fullbleed");
//     return () => document.body.classList.remove("eventlist-fullbleed");
//   }, []);

//   useEffect(() => {
//     if (!tenant) {
//       console.error("Tenant ID is missing!");
//       setError("Tenant ID is missing.");
//       setLoading(false);
//       return;
//     }

//     (async () => {
//       try {
//         const url = `${baseUrl}/api/events/${tenant}/events`;
//         const res = await axios.get(url);

//         if (res?.data?.success) {
//           const list = Array.isArray(res.data.data) ? res.data.data : [];
//           setEvents(list);
//         } else {
//           throw new Error(res?.data?.message || "Failed to fetch events.");
//         }
//       } catch (err) {
//         console.error("Error fetching events:", err);
//         setError(err?.response?.data?.message || "Failed to fetch events.");
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, [tenant, baseUrl]);

//   const handleCancel = () => navigate(`/${tenant}/dashboard`);

//   // Compute cutoff once per render: "current date + 1 day"
//   // (Uses local time on the device, which matches the UX expectation in a PWA)
//   const cutoffDate = useMemo(() => {
//     const d = new Date();
//     d.setDate(d.getDate() + 1);
//     return d;
//   }, []);

//   // Filter events for display using "status" (active) + enddate rules
//   const visibleEvents = useMemo(() => {
//     if (!Array.isArray(events) || events.length === 0) return [];
//     return events.filter((evt) => shouldDisplayEventInList(evt, cutoffDate));
//   }, [events, cutoffDate]);

//   if (loading)
//     return (
//       <div className="feed-page">
//         <div className="feed">Loading events…</div>
//       </div>
//     );

//   if (error)
//     return (
//       <div className="feed-page">
//         <div className="feed" style={{ color: "#f77" }}>
//           Error: {String(error)}
//         </div>
//       </div>
//     );

//   // IMPORTANT: empty-state should reflect filtered list, not raw list
//   if (!visibleEvents.length)
//     return (
//       <div className="feed-page">
//         <div className="feed">No events available.</div>
//       </div>
//     );

//   return (
//     <div className="feed-page">
//       <div className="feed">
//         {visibleEvents.map((evt) => {
//           const media = pickMediaFromEvent(evt);
//           const src = toAbs(baseUrl, media?.path || media?.url || media);
//           const vid = isVideo(media);
//           const img = isImage(media);
//           const goToEvent = () => navigate(`/${tenant}/${evt.id}/eventDetail`);

//           return (
//             <article key={evt.id} className="feed-card">
//               {/* header -> event details/add items */}
//               <div
//                 className="feed-card__header"
//                 onClick={goToEvent}
//                 style={{ cursor: "pointer" }}
//               >
//                 {/* <img
//                   className="feed-avatar"
//                   src={toAbs(baseUrl, evt?.avatar || "/public/app/default-avatar.png")}
//                   alt=""
//                 /> */}
//                 <div>
//                   <div className="feed-card__title">
//                     {evt?.name || `Event ${evt?.id}`}
//                   </div>
//                   <div className="feed-card__sub">
//                     {evt?.startdate && new Date(evt.startdate).toLocaleString()}
//                   </div>
//                 </div>
//               </div>

//               {/* edge-to-edge media */}
//               {vid ? (
//                 <video
//                   className="feed-media"
//                   src={src}
//                   controls
//                   preload="metadata"
//                   playsInline
//                 />
//               ) : (
//                 <img
//                   className="feed-media"
//                   // src={img ? src : toAbs(baseUrl, "/public/app/default-image.png")}
//                   src={img ? src : toAbs(baseUrl, "/public/event.png")}
//                   alt={evt?.name || "Event"}
//                   onClick={goToEvent}
//                 />
//               )}

//               {(evt?.description || evt?.location) && (
//                 <div className="feed-card__body">
//                   {evt?.description && <div>{evt.description}</div>}
//                   {evt?.location && (
//                     <div className="feed-card__sub">{evt.location}</div>
//                   )}
//                 </div>
//               )}
//             </article>
//           );
//         })}

//         <AppFooter
//           buttons={[
//             {
//               icon: <FaHome />,
//               label: "Home",
//               onClick: handleCancel,
//             },
//             {
//               icon: <FaPlus />,
//               label: "Add Event",
//               onClick: () => navigate(`/${tenant}/eventAdd`),
//             },
//           ]}
//         />
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import AppFooter from "../AppFooter";
import { FaTimes, FaShare, FaHome, FaPlus } from "react-icons/fa";
import SearchFilterBar from "../shared/SearchFilterBar";

// make relative paths absolute using your API base
const toAbs = (baseUrl, p) =>
  !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith("/") ? "" : "/"}${p}`;

const isImage = (f) =>
  f?.mimetype?.startsWith("image/") ||
  /\.(png|jpe?g|gif|webp|svg)$/i.test(f?.path || f?.url || f || "");

const isVideo = (f) =>
  f?.mimetype?.startsWith("video/") ||
  /\.(mp4|mov|webm|ogg)$/i.test(f?.path || f?.url || f || "");

const pickMediaFromEvent = (evt) => {
  // try common server shapes you use in other places
  const arr = evt?.media || evt?.files || evt?.fileList || [];
  const primary = Array.isArray(arr) ? arr[0] : arr;
  if (primary) return primary;

  return (
    evt?.cover ||
    evt?.image ||
    evt?.image_url ||
    evt?.thumbnail ||
    evt?.banner ||
    null
  );
};

/**
 * Safely parse dates coming from MySQL/Node.
 * - Handles ISO strings
 * - Handles common "YYYY-MM-DD HH:mm:ss" by normalizing to "YYYY-MM-DDTHH:mm:ss"
 * Returns: Date | null
 */
const safeParseDate = (value) => {
  if (!value) return null;

  // Already a Date?
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;

  // Try native parse first
  const d1 = new Date(value);
  if (!Number.isNaN(d1.getTime())) return d1;

  // Normalize "YYYY-MM-DD HH:mm:ss" -> "YYYY-MM-DDTHH:mm:ss"
  if (typeof value === "string" && value.includes(" ")) {
    const normalized = value.replace(" ", "T");
    const d2 = new Date(normalized);
    if (!Number.isNaN(d2.getTime())) return d2;
  }

  return null;
};

// Hide the tenant default "Timeline" event from list UIs
const isTimelineEvent = (evt) => {
  const name = String(evt?.name ?? evt?.title ?? "").trim().toLowerCase();
  const type = String(evt?.type ?? evt?.eventtype ?? "").trim().toLowerCase();
  return name === "timeline" || type === "timeline";
};

/**
 * Business rule:
 * 1) If an event's end date is <= (current date + 1 day), DO NOT display it
 * 2) If an event's end date is >  (current date + 1 day), DO display it
 *
 * Also uses "status" via event.active (schema: t_event.active).
 * - If event.active is missing (older backend payload), we assume active to avoid breaking existing behavior.
 */
// const shouldDisplayEventInList = (evt, cutoffDate) => {
//   // "status" / active flag handling (supports 1/0, true/false, "1"/"0")
//   const hasActiveField = evt?.active !== undefined && evt?.active !== null;
//   const isActive =
//     !hasActiveField ||
//     evt.active === true ||
//     evt.active === 1 ||
//     evt.active === "1";

//   if (!isActive) return false;

//   const end = safeParseDate(evt?.enddate);

//   // If enddate is missing/invalid, keep it visible (safer fallback; avoids hiding everything)
//   if (!end) return true;

//   // Rule 1: enddate <= now+1 day => hide
//   return end > cutoffDate;
// };

const shouldDisplayEventInList = (evt, cutoffDate) => {
  // ✅ Always hide Timeline
  if (isTimelineEvent(evt)) return false;

  // "status" / active flag handling (supports 1/0, true/false, "1"/"0")
  const hasActiveField = evt?.active !== undefined && evt?.active !== null;
  const isActive =
    !hasActiveField ||
    evt.active === true ||
    evt.active === 1 ||
    evt.active === "1";

  if (!isActive) return false;

  const end = safeParseDate(evt?.enddate);

  // If enddate is missing/invalid, keep it visible (safer fallback; avoids hiding everything)
  if (!end) return true;

  // Rule 1: enddate <= now+1 day => hide
  return end > cutoffDate;
};

export default function EventList() {
  const { tenant } = useParams();
  const navigate = useNavigate();

  const { t } = useTranslation();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

  useEffect(() => {
    document.body.classList.add("eventlist-fullbleed");
    return () => document.body.classList.remove("eventlist-fullbleed");
  }, []);

  useEffect(() => {
    if (!tenant) {
      console.error("Tenant ID is missing!");
      setError("Tenant ID is missing.");
      setLoading(false);
      return;
    }

    (async () => {
      try {
        const url = `${baseUrl}/api/events/${tenant}/events`;
        const res = await axios.get(url);

        if (res?.data?.success) {
          const list = Array.isArray(res.data.data) ? res.data.data : [];
          setEvents(list);
        } else {
          throw new Error(res?.data?.message || "Failed to fetch events.");
        }
      } catch (err) {
        console.error("Error fetching events:", err);
        setError(err?.response?.data?.message || "Failed to fetch events.");
      } finally {
        setLoading(false);
      }
    })();
  }, [tenant, baseUrl]);

  const handleCancel = () => navigate(`/${tenant}/dashboard`);

  // Compute cutoff once per render: "current date + 1 day"
  // (Uses local time on the device, which matches the UX expectation in a PWA)
  const cutoffDate = useMemo(() => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return d;
  }, []);

  // Filter events for display using "status" (active) + enddate rules
  const visibleEvents = useMemo(() => {
    if (!Array.isArray(events) || events.length === 0) return [];
    let result = events.filter((evt) => shouldDisplayEventInList(evt, cutoffDate));

    const q = searchTerm.trim().toLowerCase();
    if (q) {
      result = result.filter((evt) => {
        const name = (evt?.name || "").toLowerCase();
        const desc = (evt?.description || "").toLowerCase();
        const loc = (evt?.location || "").toLowerCase();
        return name.includes(q) || desc.includes(q) || loc.includes(q);
      });
    }
    if (dateFrom) {
      const from = new Date(dateFrom);
      result = result.filter((evt) => {
        const start = safeParseDate(evt?.startdate);
        return start ? start >= from : true;
      });
    }
    if (dateTo) {
      const to = new Date(dateTo + "T23:59:59");
      result = result.filter((evt) => {
        const start = safeParseDate(evt?.startdate);
        return start ? start <= to : true;
      });
    }
    return result;
  }, [events, cutoffDate, searchTerm, dateFrom, dateTo]);

  if (loading)
    return (
      <div className="feed-page">
        <div className="feed">{t('events.loading')}</div>
      </div>
    );

  if (error)
    return (
      <div className="feed-page">
        <div className="feed" style={{ color: "#f77" }}>
          {t('common.error')}: {String(error)}
        </div>
      </div>
    );

  // IMPORTANT: empty-state should reflect filtered list, not raw list
  if (!visibleEvents.length)
    return (
      <div className="feed-page">
        <div className="feed">{t('events.noEventsAvailable')}</div>
      </div>
    );

  return (
    <div className="feed-page">
      <div className="feed">
        <SearchFilterBar
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          dateFrom={dateFrom}
          dateTo={dateTo}
          onDateFromChange={setDateFrom}
          onDateToChange={setDateTo}
          onClear={() => { setSearchTerm(""); setDateFrom(""); setDateTo(""); }}
          searchPlaceholder="Search events\u2026"
        />
        {visibleEvents.length === 0 && (searchTerm || dateFrom || dateTo) && (
          <div style={{ textAlign: "center", padding: "24px 0", color: "#a8a8a8" }}>
            No events match your filters.
          </div>
        )}
        {visibleEvents.map((evt) => {
          const media = pickMediaFromEvent(evt);
          const src = toAbs(baseUrl, media?.path || media?.url || media);
          const vid = isVideo(media);
          const img = isImage(media);
          const goToEvent = () => navigate(`/${tenant}/${evt.id}/eventDetail`);

          return (
            <article key={evt.id} className="feed-card">
              {/* header -> event details/add items */}
              <div
                className="feed-card__header"
                onClick={goToEvent}
                style={{ cursor: "pointer" }}
              >
                {/* <img
                  className="feed-avatar"
                  src={toAbs(baseUrl, evt?.avatar || "/public/app/default-avatar.png")}
                  alt=""
                /> */}
                <div>
                  <div className="feed-card__title">
                    {evt?.name || `Event ${evt?.id}`}
                  </div>
                </div>
              </div>

              {/* edge-to-edge media */}
              {vid ? (
                <video
                  className="feed-media"
                  src={src}
                  controls
                  preload="metadata"
                  playsInline
                />
              ) : (
                <img
                  className="feed-media"
                  // src={img ? src : toAbs(baseUrl, "/public/app/default-image.png")}
                  src={img ? src : toAbs(baseUrl, "/public/event.png")}
                  alt={evt?.name || "Event"}
                  onClick={goToEvent}
                />
              )}

              {(evt?.description || evt?.location) && (
                <div className="feed-card__body">
                  {evt?.description && <div>{evt.description}</div>}
                  {evt?.location && (
                    <div className="feed-card__sub">{evt.location}</div>
                  )}
                </div>
              )}
            </article>
          );
        })}

        <AppFooter
          buttons={[
            {
              icon: <FaHome />,
              label: t('common.home'),
              onClick: handleCancel,
            },
            {
              icon: <FaPlus />,
              label: t('events.addEvent'),
              onClick: () => navigate(`/${tenant}/eventAdd`),
            },
          ]}
        />
      </div>
    </div>
  );
}